import { FC } from 'react'

import { PieChart } from '@rsuite/charts'

type ChartType =
  | 'user-channel-pie'
  | 'wallet-pie'
  | 'Admin-wallet-pie'
  | 'Admin-channel-pie'
  | 'Admin-compaign-pie'
  | 'Admin-Template-pie'
  | 'user-Template-pie'
  | 'user-compaign-pie'

interface ChartProps {
  type: ChartType;
  options?: any;
  data?: any;
}
const convertToChartData = (data: Record<string, number>) => {
  return [['Visit Source', 'Percentage'], ...Object.entries(data)]
}
const Charts: FC<ChartProps> = ({ type, options, data }) => {
  const color = ['#5ea650', '#34c3ff', '#ff941f']
  const Walletcolors = ['#ce1e1e', '#5ea650']
  const AdminCompaigncolors = ['#5ea650', '#4099bc', '#ff941f']
  switch (type) {
    case 'user-channel-pie': {
      const channelData = data ? convertToChartData(data) : []
      return (
        <PieChart
          data={channelData}
          legend={false}
          {...options}
          color={color}
        />
      )
    }
    case 'Admin-channel-pie': {
      const adminChannel = data ? convertToChartData(data) : []
      return (
        <PieChart
          data={adminChannel}
          legend={false}
          {...options}
          color={color}
        />
      )
    }
    case 'wallet-pie': {
      return (
        <PieChart
          data={data}
          innerRadius={0.6}
          legend={false}
          donut
          {...options}
          color={Walletcolors}
        />
      )
    }
    case 'Admin-wallet-pie': {
      return (
        <PieChart
          data={data}
          innerRadius={0.6}
          legend={false}
          donut
          {...options}
          color={Walletcolors}
        />
      )
    }
    case 'user-compaign-pie': {
      const formattedData = data ? convertToChartData(data) : []
      return (
        <PieChart
          data={formattedData}
          innerRadius={0.6}
          legend={false}
          donut
          {...options}
          color={AdminCompaigncolors}
        />
      )
    }
    case 'Admin-compaign-pie': {
      const adminCampaign = data ? convertToChartData(data) : []
      return (
        <PieChart
          data={adminCampaign}
          innerRadius={0.6}
          legend={false}
          donut
          {...options}
          color={AdminCompaigncolors}
        />
      )
    }
    case 'user-Template-pie': {
      const userTemplate = data ? convertToChartData(data) : []
      return (
        <PieChart
          data={userTemplate}
          innerRadius={0.6}
          legend={false}
          donut
          {...options}
          color={AdminCompaigncolors}
        />
      )
    }
    case 'Admin-Template-pie': {
      const AdminTemplate = data ? convertToChartData(data) : []
      return (
        <PieChart
          data={AdminTemplate}
          innerRadius={0.6}
          legend={false}
          donut
          {...options}
          color={AdminCompaigncolors}
        />
      )
    }
    default:
      return <div>Invalid chart type</div>
  }
}

export default Charts
